import listIngredients from "./listIngredients"
export default listIngredients;
